export default "__VITE_ASSET__9jo7JrRl__"